import React from "react"
import {
  VirtualizedTable,
  useAppContext,
  VirtualList,
  apiClient,
  paginated,
  ErrorWithRefetch,
} from "@dit/core-frontend"
import { Box, Stack } from "@mos-cat/ds"
import { API_ENDPOINTS } from "@constants"
import { createTableConfig } from "@pages/Zones/createTableConfig"
import useZonesList from "@components/zones/useZonesList"
import ZoneListItem from "@components/zones/ZoneListItem"
import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { ZoneCardsTable } from "./ZoneCardsTable"

export const ZonesList = ({ view = "list", isRowView = true, userZone }) => {
  const { isMobileView, isMoshub } = useAppContext()
  const { params } = useZonesList()
  const queryClient = useQueryClient()
  const { isFetching, data, fetchNextPage, hasNextPage, error, refetch } = useInfiniteQuery({
    ...paginated({
      queryKey: ["zones", params, userZone],
      queryFn: (pagginated) =>
        apiClient.get(API_ENDPOINTS.zoneList, {
          params: {
            ...params,
            ...pagginated,
          },
        }),
    }),
  })

  const handleUpdate = useMutation({
    mutationFn: () => true,
    onMutate: ({ id, value }) => {
      queryClient.setQueryData(["zones", params, userZone], (prev) => {
        const newData = {
          ...prev,
          pages: prev.pages.map((page) => ({
            ...page,
            data: {
              ...page.data,
              data: {
                ...page.data.data,
                itemsList: page.data.data.itemsList.map((item) =>
                  item.id === id ? { ...item, ...value } : item,
                ),
              },
            },
          })),
        }
        return newData
      })
    },
  })

  const updateResponseData = (id, type, value) => {
    if (type === "remove") {
      refetch()
      return
    }
    handleUpdate.mutate({ id, value })
    refetch()
  }

  if (view === "list") {
    const tableConfig = createTableConfig(updateResponseData, isMoshub)

    return (
      <Box position="relative" minHeight="292px" overflow="auto" height="100%">
        {error ? (
          <ErrorWithRefetch refetch={refetch} />
        ) : isMobileView ? (
          <VirtualList
            over={10}
            dataList={data?.items || []}
            hasNextPage={hasNextPage}
            isLoading={isFetching}
            infiniteScroll
            infiniteCount={2}
            height={500}
            renderItem={(zone) => (
              <ZoneListItem zone={zone} updateResponseData={updateResponseData} />
            )}
            onLoad={fetchNextPage}
          />
        ) : (
          <VirtualizedTable
            over={10}
            dataList={data?.items || []}
            hasNextPage={hasNextPage}
            tableConfig={tableConfig}
            emptyText="Нет разделов"
            isLoading={isFetching}
            onLoad={fetchNextPage}
            infiniteScroll
            infiniteCount={2}
          />
        )}
      </Box>
    )
  }
  return (
    <Stack space="0">
      {error ? (
        <ErrorWithRefetch refetch={refetch} />
      ) : (
        <ZoneCardsTable
          data={data}
          isFetching={isFetching}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          infiniteCount={1}
          isDisableFetch={isRowView}
          updateResponseData={updateResponseData}
          isMobileView={isMobileView}
          isRowView={isRowView}
        />
      )}
    </Stack>
  )
}
